var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.945 21.292h-2.822l9.17-9.17v2.823h2V8.709h-6.238v2h2.823l-9.169 9.169v-2.822h-2v6.236h6.236z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.709 26.292h20.583V5.709H5.709v20.583zM27.292 3.709H4.709a1 1 0 00-1 1v22.583a1 1 0 001 1h22.583a1 1 0 001-1V4.709a1 1 0 00-1-1z"
  })))));
}

export default SvgIconRoomSize;